import { useCallback, useEffect, useState } from 'react'
import type { Invoice } from './types'

function useInvoice(uuid: string | undefined | null) {
	const [invoice, setInvoice] = useState<Invoice>()

	const [loading, setLoading] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)

	const doQuery = useCallback(async () => {
		if (!uuid) return
		setLoading(true)
		setError(null)
		let data: Invoice | undefined

		try {
			const response = { ok: true } //await _getInvoice(uuid)

			if (response && response.ok) {
				//const res = await response.json()
				//data = res.invoice
				data = {
					uuid: 1,
					createdAt: '2025-07-15',
					updatedAt: '2025-07-15',
					invoiceNumber: 1,
					name: 'Taalasmaa Seppo',
					customerNumber: 1,
					date: '2025-01-01',
					dueDate: '2025-01-15',
					amount: 250.0,
				}
			} else {
				throw new Error('Response is not ok.')
			}
		} catch (err) {
			console.error('Error fetching invoice:', err)
			setError('An error occurred while fetching invoice: ' + uuid)
		}
		setInvoice(data)
		setLoading(false)
	}, [uuid])

	useEffect(() => {
		doQuery()
	}, [doQuery])

	return {
		invoice,
		loading,
		error,
		refresh: doQuery,
	}
}

export type useInvoiceResult = ReturnType<typeof useInvoice>

export default useInvoice
